import { SectionEyebrow } from "@/components/ui/SectionEyebrow";
import { FAQAccordion } from "@/components/ui/FAQAccordion";
import { homeFaqs } from "@/data/faqs";

export function FAQSection() {
  return (
    <section className="mx-auto max-w-3xl px-5 py-20 lg:px-8">
      <div className="text-center">
        <SectionEyebrow>Frequently Asked Questions</SectionEyebrow>
        <h2 className="mt-5 font-display text-3xl font-semibold text-text-primary sm:text-4xl">
          Common Questions, Answered
        </h2>
      </div>
      <div className="mt-10">
        <FAQAccordion items={homeFaqs} />
      </div>
    </section>
  );
}
